import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryQualityInspection extends BaseModelAPI {
	static entity = 'newobject1918';
	static entityName = 'deliveryqualityinspection';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.deliveryQualityInspectionNo = '';
			this.deliveryInstructionId = '';
			this.deliveryInstruction = {};
			this.deliveryQualityInspectionStatusId = '';
			this.deliveryQualityInspectionStatus = {};
			this.deliveryQualityInspectionDetail = []
			this.deliveryQualityInspectionCard = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}